import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeatureBlock1 } from "./FeatureBlock1";
import { FeatureBlock2 } from "./FeatureBlock2";
import { FeatureBlock3 } from "./FeatureBlock3";
import { FeatureBlock4 } from "./FeatureBlock4";

export const featureBlocks: BlockExportMapping = {
  FeatureBlock1,
  FeatureBlock2,
  FeatureBlock3,
  FeatureBlock4,
};
